import { useState, useEffect } from 'react';
import { REPOSITORIO_URL } from '~/constant';

const CACHE_BUCKET_MS = 5 * 60 * 1000;
const getCacheBucket = () => Math.floor(Date.now() / CACHE_BUCKET_MS);

const cache = {};

const useDynamicSvg = codigoFamilia => {
  const buildKey = id => `${id}-${getCacheBucket()}`;
  const [svgContent, setSvgContent] = useState(
    () => cache[buildKey(codigoFamilia)] || null
  );
  const [loading, setLoading] = useState(!cache[buildKey(codigoFamilia)]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!codigoFamilia) return;

    const bucket = getCacheBucket();
    const cacheKey = `${codigoFamilia}-${bucket}`;

    if (cache[cacheKey]) {
      setSvgContent(cache[cacheKey]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const url = `${REPOSITORIO_URL}/empreendimentos/mapas/${codigoFamilia}.svg?v=${bucket}`;

    fetch(url)
      .then(res => {
        if (!res.ok) throw new Error(`Erro ao carregar mapa: ${res.status}`);
        return res.text();
      })
      .then(text => {
        if (cancelled) return;
        cache[cacheKey] = text;
        setSvgContent(text);
        setLoading(false);
      })
      .catch(err => {
        if (cancelled) return;
        setError(err.message);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [codigoFamilia]);

  return { svgContent, loading, error };
};

export default useDynamicSvg;
